/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect,
} from 'react';
import { TWIAAddressComponent } from 'twia-capability-address-component';
import metadata from './Echeck.metadata.json5';
import styles from './Echeck.module.scss';
import messages from './Echeck.messages'
import { Link } from '@jutro/router';

function Echeck(props) {
    const {
        bindDataVM,
        writeValue,
        onValidate,
        showError
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const country = _.get(bindDataVM, 'paymentDetails.electronicPaymentData_TWIA.mailingAddress.country.value.code');
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('Echeck');
    //const paymentOption = _.get(bindDataVM, 'paymentDetails.nonEFTPaymentOption_TWIA.value.code')
    //const isEcheck = paymentOption === 'echeck' ? true : false;

    const isEcheck = true;
    
    const translator = useTranslator();

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, 'Echeck');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        const myEmailInput = document.getElementsByName('confirmEmail');
        const myAccountInput = document.getElementsByName('confirmAccountNumber');

        myEmailInput[0].onpaste = () => false;
        myAccountInput[0].onpaste = () => false;
    })

    const handleValueChange = useCallback((value, path) => {
        // DE18300
        const removeDecimals = (val) => val.toString().split('.')[0];

        if (path.includes('bankAccountNumber') || path.includes('confirmBankAccountNumber')) {
            writeValue(removeDecimals(value), path);
            return;
        }

        if (path.includes('isCommercialAccount') && value) {
            writeValue(false, 'paymentDetails.electronicPaymentData_TWIA.isSavings');
        }

        writeValue(value, path);
    }, [writeValue]);

    const getUrlAndOpen = () => {
        const myWindow = window.open();

        myWindow.location.href = 'https://www.twia.org/wp-content/uploads/2017/12/eCheck-Payment-Processing-Guide.pdf';
    };

    const getPaymentText = useCallback(() => (
        <span>
            <b>{translator(messages.guidelines)}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, react/jsx-no-literals */}
            <Link onClick={() => { getUrlAndOpen() }}>
                here
            {/* eslint-disable-next-line react/jsx-no-literals */}
            </Link>.
            </b>
        </span>
    ), [translator]);

    const getTermsText = useCallback(() => (
        <div>
            <b>{translator(messages.readAndApprove)}</b>
            <br /><br />
            <b>{translator(messages.byClicking)}</b>
            <br /><br />
            <b>{translator(messages.returnPayment)}</b>
        </div>
    ), [translator]);

    const showEmailConfirmMessage = useCallback(() => {
        const confirmEmail = _.get(bindDataVM,'paymentDetails.electronicPaymentData_TWIA.confirmEmail.value');
        const accountEmail = _.get(bindDataVM,'paymentDetails.electronicPaymentData_TWIA.email.value');
        const confirmEmailValidationMsgs = _.get(bindDataVM,'paymentDetails.electronicPaymentData_TWIA.confirmEmail.aspects.validationMessages');
        const accountEmailValidationMsgs = _.get(bindDataVM,'paymentDetails.electronicPaymentData_TWIA.email.aspects.validationMessages');
        
        return !_.isUndefined(accountEmail) && !_.isUndefined(confirmEmail) 
        && accountEmail === confirmEmail && _.isEmpty(confirmEmailValidationMsgs) 
        && _.isEmpty(accountEmailValidationMsgs)
    }, [bindDataVM])

    const updatePolicyAddressVM = useCallback((value) => {
        writeValue(value, 'paymentDetails.electronicPaymentData_TWIA.mailingAddress');
    }, [writeValue]);

    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        paymentText: {
            content: getPaymentText()
        },
        guidelinesText: {
            content: <b>{translator(messages.paymentEcheck)}</b>
        },
        echeckTerms: {
            content: getTermsText()
        },
        confirmMsg: {
            visible: showEmailConfirmMessage()
        },
        accountType: {
            disabled: _.get(bindDataVM, 'paymentDetails.electronicPaymentData_TWIA.isCommercialAccount.value') === true,
            tooltip: {
                text: _.get(bindDataVM, 'paymentDetails.electronicPaymentData_TWIA.isCommercialAccount.value') === true ? translator(messages.businessAccount) : ""
            }
        },
        savingsMessage:{
            visible:  _.get(bindDataVM, 'paymentDetails.electronicPaymentData_TWIA.isSavings.value') === true,
            content: <b>{translator(messages.savingsMsg)}</b>
        },
        addressComponent: {
            visible: !_.isUndefined(_.get(bindDataVM,'paymentDetails.electronicPaymentData_TWIA.mailingAddress')),
            // eslint-disable-next-line no-secrets/no-secrets
            addressVM: _.get(bindDataVM,'paymentDetails.electronicPaymentData_TWIA.mailingAddress'),
            updatePolicyAddressVM, country, showError, 
            onValidate, isEcheck
        },
        phoneNumber: {
            // validationMessages: _.get(bindDataVM, 'paymentDetails.electronicPaymentData_TWIA.homePhoneNumber.aspects.validationMessages'),
            showErrors: true
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            handleValueChange
        },
        resolveComponentMap: {
            twiaAddressComponent: TWIAAddressComponent
        },
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={bindDataVM}
            onValueChange={handleValueChange}
            onValidationChange={setComponentValidation}
            showErrors={showError}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )
}

Echeck.propTypes = wizardProps;
export default Echeck;
